<div class="container">
  <div class="content">
    <img class="logo" src="assets/icons/tc_logo.svg" alt="" />

    <div class="title-section">
      <h1 class="title">Cambiá tu contraseña</h1>
      <h3 class="subtitle">¡Que lindo tenerte de vuelta!</h3>
    </div>

    <form class="signin-form" [formGroup]="recoverPasswordForm">
      <div class="form" (keyup.enter)="changePassword()">
        <mat-form-field appearance="outline">
          <input
            matInput
            [type]="seePassword ? 'text' : 'password'"
            name="password"
            formControlName="passwordControl"
            placeholder="Nueva contraseña"
          />
          <img
            class="eye-icon"
            src="assets/icons/eye.svg"
            *ngIf="!seePassword"
            (click)="seePassword = true"
            alt=""
          />
          <img
            class="eye-off-icon"
            src="assets/icons/eye-off.svg"
            *ngIf="seePassword"
            (click)="seePassword = false"
            alt=""
          />
          <mat-error
            for="register-password"
            *ngIf="
              !recoverPasswordForm.controls['passwordControl'].pristine &&
              recoverPasswordForm.controls['passwordControl'].invalid
            "
          >
            {{
              utils.getErrorMessage(recoverPasswordForm.controls['passwordControl'].errors)
            }}</mat-error
          >
        </mat-form-field>
        <mat-form-field appearance="outline">
          <input
            matInput
            [type]="seeRepPassword ? 'text' : 'password'"
            name="password"
            formControlName="repeatPasswordControl"
            placeholder="Repetir contraseña"
          />
          <img
            class="eye-icon"
            src="assets/icons/eye.svg"
            *ngIf="!seeRepPassword"
            (click)="seeRepPassword = true"
            alt=""
          />
          <img
            class="eye-off-icon"
            src="assets/icons/eye-off.svg"
            *ngIf="seeRepPassword"
            (click)="seeRepPassword = false"
            alt=""
          />
          <mat-error
            for="register-password"
            class="form-error"
            *ngIf="
              !recoverPasswordForm.controls['repeatPasswordControl'].pristine &&
              recoverPasswordForm.controls['repeatPasswordControl'].invalid
            "
          >
            {{
              utils.getErrorMessage(recoverPasswordForm.controls['repeatPasswordControl'].errors)
            }}</mat-error
          >
        </mat-form-field>
        <button class="td-btn primary" (click)="changePassword()">Cambiar contraseña</button>
      </div>
    </form>

    <div class="options">
      <div class="option">
        <p class="text" (click)="router.navigate(['auth', 'signin'])">Volver al inicio de sesión</p>
      </div>
    </div>

    <div class="footer">
      <p class="text" (click)="utils.openTyc()">Términos y Condiciones</p>
      <p class="text">© TiendaCrypto {{ utils.actualYear }}</p>
    </div>
  </div>
</div>
